<template>
    <div v-if="images"
        class="owl-carousel"
        :id="['owl-' + unitid]">
        <div v-for="img in images.slice(0, 3)"
            class="item">
            <a :href="getUnitPath()"
                :target="getTarget()">
                <img-fallback :img="img.id"
                    mode="img"
                    img-format="l"
                    vo-msg:placeholder="no.pic.placeholder"></img-fallback>
            </a>

        </div>
    </div>
    <div v-else>
        <img-fallback mode="img"
            vo-msg:placeholder="no.pic.placeholder"></img-fallback>
    </div>
</template>

<script>
    import V from 'voUtils/V.js'



    export default {
    	voVueComponent: 'img-carousel',
    	props: {
    		images: Array,
    		default: () => [{
    			id: -1,
    			width: 450,
    			height: 300,
    			name: '//via.placeholder.com/450x300&text=No%20Image'
    		}],
    		unitid: Number,
    		unitpath: String

    	},

    	mounted: function() {
    		console.log('Images::', this.images);
    		$("#owl-" + this.unitid).owlCarousel({
    			items: 1,
    			loop: true,
    			center: false,
    			autoplay: false,
    			smartSpeed: 3000,
    			lazyLoad: true,
    			dots: true,
    			nav: true
    		});
    	},

    	methods: {
    		getTarget: function() {
    			return this.$root.getUnitSearchTarget(this.unitid);
    		},
    		getUnitPath: function() {
    			return this.$root.getUnitSearchPath(this.unitpath);
    		}
    	}

    };
</script>